import styled from 'styled-components';
import { InputNumber } from 'antd';

export const MinMax = styled(InputNumber)`
  color: ${props => props.theme.fontColors.greyishBrown};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  background-color: ${props => props.theme.backgroundColor.layoutLight};
  width: 100px;
  height: 32px;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 520px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }

  & .ant-input-number-input-wrap .ant-input-number-input {
    border-radius: 0 !important;
  }
  &.ant-input-number-focused {
    border: 1px solid ${props =>props.theme.border.inputBox} !important;
    outline-color: ${props =>props.theme.border.inputBox} !important;
    outline-width: 1px !important;
    box-shadow: none !important;
  }
  &:hover {
    border: 1px solid ${props => props.theme.colors.lightGrey};
  }
`;
